import React from 'react';
import PropTypes from 'prop-types';
import Badge from '../badge';
import style from '../order-alerts-components.module.less';

const ShipTogetherName = ({ name = '', count = 0, allowForDigitCount = 1 }) => {
  const pixelsPerDigit = 15;
  const styleHash = {
    textAlign: 'right',
    minWidth: `${allowForDigitCount * pixelsPerDigit}px`,
    display: 'flex',
    justifyContent: 'flex-end',
  };
  return (
    <div className={style.name}>
      <div style={styleHash}>
        <Badge value={count} />
      </div>
      <div className={style['name-title']}>{name}</div>
    </div>
  );
};

ShipTogetherName.propTypes = {
  name: PropTypes.string,
  count: PropTypes.number,
  allowForDigitCount: PropTypes.number,
};

export default ShipTogetherName;
